import React, { useMemo } from "react";
import { DayPicker } from "react-day-picker";
import styled, { css } from "styled-components";
import "react-day-picker/style.css";
import { isValidDate, toDateObject, adjustFormat } from "util/DateTime";
const StyledDayPicker = styled(DayPicker)(
  ({ theme }) => css`
    width: 100%;

    --rdp-accent-color: ${theme.colors.variant.primary};
    --rdp-disabled-opacity: 0.4;
    --rdp-day-width: 34px;
    --rdp-day-height: 34px;
    --rdp-day_button-width: 34px;
    --rdp-day_button-height: 34px;

    .rdp-chevron {
      fill: ${theme.colors.gray[60]};
    }

    .rdp-months {
      margin: 0 auto;
    }
  `
);
const useSelectedDate = (date) => useMemo(() => {
  const isDateValid = !date || isValidDate(toDateObject(date, ["date"]));
  if (isDateValid) {
    return date;
  }
  return void 0;
}, [date]);
const DatePicker = ({
  date = void 0,
  fromDate = void 0,
  onChange,
  showOutsideDays = false,
  timeZone = "UTC"
}) => {
  const selectedDate = useSelectedDate(date);
  const modifiers = useMemo(
    () => ({
      selected: (moddedDate) => {
        if (!selectedDate) {
          return false;
        }
        return selectedDate === adjustFormat(moddedDate, "date", timeZone);
      },
      disabled: {
        before: new Date(fromDate)
      }
    }),
    [fromDate, selectedDate, timeZone]
  );
  return /* @__PURE__ */ React.createElement(
    StyledDayPicker,
    {
      defaultMonth: selectedDate ? toDateObject(selectedDate).toDate() : void 0,
      onDayClick: onChange,
      modifiers,
      timeZone,
      showOutsideDays
    }
  );
};
export default DatePicker;
